import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-100 border-t border-foreground-950/12">
      <div className="w-full px-4 md:px-10 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-newspaper-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料免费</span>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-600 max-w-sm">
              一个把获取方式、渠道入口和使用攻略讲清楚的内容索引站。
              内容以公开信息整理为主，目的是让人少走弯路，零门槛直接上手。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#index"
                aria-label="回到本期导读"
                className="w-10 h-10 flex items-center justify-center rounded-md border border-foreground-950/15 text-foreground-700 hover:text-primary-600 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-up-line text-lg"></i>
              </a>
              <a
                href="#collections"
                aria-label="查看吃瓜合集"
                className="w-10 h-10 flex items-center justify-center rounded-md border border-foreground-950/15 text-foreground-700 hover:text-primary-600 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <i className="ri-bookmark-3-line text-lg"></i>
              </a>
              <a
                href="#subscribe"
                aria-label="订阅更新提醒"
                className="w-10 h-10 flex items-center justify-center rounded-md border border-foreground-950/15 text-foreground-700 hover:text-primary-600 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <i className="ri-rss-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="md:col-span-2">
              <h3 className="text-sm font-medium text-foreground-950">{column.title}</h3>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <h3 className="text-sm font-medium text-foreground-950">声明</h3>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              本站仅整理公开信息与使用指引。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-foreground-950/12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            黑料免费 · 获取方式与渠道入口，看攻略不走弯路
          </p>
          <p className="text-xs text-foreground-500">
            内容整理 · 索引更新 · 攻略维护
          </p>
        </div>
      </div>
    </footer>
  );
}